module.exports = __webpack_public_path__ + "static/cardOnSide-7bbd40d0731627b06baffb51154286e8.png";